import { render, staticRenderFns } from "./ComboImportAsignacion.vue?vue&type=template&id=0c671420&scoped=true"
import script from "./ComboImportAsignacion.vue?vue&type=script&lang=js"
export * from "./ComboImportAsignacion.vue?vue&type=script&lang=js"
import style0 from "./ComboImportAsignacion.vue?vue&type=style&index=0&id=0c671420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c671420",
  null
  
)

export default component.exports